module.exports = __webpack_public_path__ + "static/media/curve.075960e4.svg";